import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearCategoryDetail, fetchCategoryDetail } from './PersonalityActions';
import { fetchInitialData } from './PersonalityHelper';

const FetchContent = ({ accessToken, deviceId, showId }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const intervalFetch = () => {
      dispatch(fetchCategoryDetail(showId, accessToken, deviceId));
    };
    const intervalId = fetchInitialData({
      accessToken,
      deviceId,
      dispatch,
      intervalFetch,
      showId,
    });
    return () => {
      if (intervalId) clearInterval(intervalId);
      dispatch(clearCategoryDetail());
    };
  }, [accessToken, showId, deviceId, dispatch]);
};

export default FetchContent;
